import React, { memo } from 'react';
import ArrowRight from 'svg/ArrowRightV2';
import LoadSpinner from 'svg/LoadSpinner';
import Link from 'components/Link';

export type EventTypeCardMobileProps = {
  title: string;
  isVairIntegrated: boolean;
  icon: string;
  getStartedHref: string;
  isRatingSession?: boolean;
  /**
   * Set for event types behind a VAIR role check: tapping the card calls this
   * instead of navigating, so the gate can route or explain what's missing.
   */
  onSelect?: () => void;
  /** VAIR role check still in flight — keeps the gated card from being tapped early. */
  isLoading?: boolean;
};

const EventTypeCardMobile = memo(function EventTypeCardMobile({
  title,
  isVairIntegrated,
  icon,
  getStartedHref,
  isRatingSession,
  onSelect,
  isLoading,
}: EventTypeCardMobileProps) {
  const content = (
    <>
      {isRatingSession && (
        <div className="absolute inset-0 h-full w-full">
          <img
            src="/images/vair/vair-banner-bg.gif"
            alt=""
            className="h-full w-full object-cover"
            aria-hidden
          />
        </div>
      )}
      <div className="relative flex items-center gap-ds-lg px-ds-lg py-ds-md text-color-text-lightmode-invert">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center">
          <img
            src={icon}
            alt=""
            className={isRatingSession ? 'h-6 w-auto object-contain' : 'h-12 w-auto object-contain'}
            aria-hidden
          />
        </div>
        <div className="flex flex-1 flex-col">
          <span className="typography-product-subheading">{title}</span>
          {isVairIntegrated && (
            <div className="flex items-center gap-1">
              <img
                src="/images/vair/vair-white.png"
                alt="VAIR"
                className="h-2.5 w-auto object-contain"
              />
              <span className="typography-product-caption text-color-text-lightmode-tertiary">
                integrated
              </span>
            </div>
          )}
        </div>
        {isLoading ? (
          <LoadSpinner className="h-5 w-5 shrink-0 animate-spin" />
        ) : (
          <ArrowRight className="h-5 w-5 shrink-0" />
        )}
      </div>
    </>
  );

  const className = 'relative block overflow-hidden rounded-2xl bg-color-bg-lightmode-invert';

  if (onSelect) {
    return (
      <button
        type="button"
        onClick={onSelect}
        disabled={isLoading}
        className={`${className} w-full text-left disabled:cursor-not-allowed`}
      >
        {content}
      </button>
    );
  }

  if (!getStartedHref) {
    return <div className={className}>{content}</div>;
  }

  return (
    <Link href={getStartedHref} className={className}>
      {content}
    </Link>
  );
});

export default EventTypeCardMobile;
